import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const GeodeLogo = ({ className = "" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="gl1" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#F4D03F" />
        <stop offset="100%" stopColor="#E07A5F" />
      </linearGradient>
      <linearGradient id="gl2" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#5B2C6F" />
        <stop offset="100%" stopColor="#1a0d20" />
      </linearGradient>
    </defs>
    <path d="M16 2 L29 11 L26 26 L16 30 L6 26 L3 11 Z" fill="url(#gl2)" stroke="rgba(255,255,255,0.1)" />
    <path d="M16 8 L23 13 L21 22 L16 24 L11 22 L9 13 Z" fill="url(#gl1)" />
    <path d="M16 8 L21 22 L11 22 Z" fill="rgba(255,255,255,0.18)" />
  </svg>
);

export const Brand = ({ size = "default" }) => {
  const textCls = size === "small" ? "text-lg" : "text-xl";
  return (
    <Link to="/" className="flex items-center gap-2.5 group" data-testid="brand-logo">
      <GeodeLogo className="w-7 h-7 transition-transform group-hover:rotate-12" />
      <span className={`font-display font-semibold tracking-tight ${textCls} text-white`}>My Leads Convert</span>
    </Link>
  );
};

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 px-6 lg:px-8 py-4">
      <div className="max-w-7xl mx-auto">
        <nav className="glass-panel rounded-full px-6 py-2.5 flex items-center justify-between">
          <Brand />
          <div className="hidden md:flex items-center gap-8 text-sm text-zinc-400">
            <a href="/#features" className="hover:text-white transition-colors" data-testid="nav-features">Features</a>
            <a href="/#how" className="hover:text-white transition-colors" data-testid="nav-how">How it works</a>
            <a href="/#faq" className="hover:text-white transition-colors" data-testid="nav-faq">FAQ</a>
          </div>
          <div className="flex items-center gap-3">
            {user && user.id ? (
              <>
                <button onClick={() => navigate("/dashboard")} className="text-sm text-zinc-300 hover:text-white" data-testid="nav-dashboard">Dashboard</button>
                <button onClick={async () => { await logout(); navigate("/"); }} className="btn-ghost text-sm" data-testid="nav-logout">Log out</button>
              </>
            ) : (
              <>
                <Link to="/login" className="text-sm text-zinc-300 hover:text-white" data-testid="nav-login">Log in</Link>
                <Link to="/register" className="btn-primary text-sm" data-testid="nav-signup">Get started</Link>
              </>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
};
